import chair from './chair.png';
import stol from './stol.png';
import komod from './komod.png';
import tumba from './tumba.png';
import shild from './shild.png';
import bed from './bed.png';

import type { LeftBlock, RightBlock } from '../../typings';

export const leftBlock: LeftBlock = [komod, chair, stol];
export const rightBlock: RightBlock = [shild, tumba, bed];
